// 风控核验sdk版本
export const RISK_SDK_VERSION = "1.6";
